// extracted by mini-css-extract-plugin
export default {"chartSelector":"chartSelector__bax_G2JuMAo2"};